<template>
  <div>
    <div class="header mb-10">
      <el-button
        @click="handleNew"
        type="primary"
        icon="el-icon-plus"
        size="small"
        v-permission="Auth.stockroomNew"
        >新增仓库</el-button
      >
    </div>
    <el-table
      v-loading="loading"
      :data="
        lists.filter(
          (data) =>
            !search || data.name.toLowerCase().includes(search.toLowerCase())
        )
      "
      stripe
      header-row-class-name="q-products-header"
    >
      <el-table-column prop="name" label="仓库名称"></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column label="负责人">
        <template slot-scope="scope">
          <span>
            {{ scope.row.user.name }}
            <br />
            {{ scope.row.user.phone_number }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注"></el-table-column>
      <el-table-column align="right">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleEdit(scope.$index, scope.row)"
            v-permission="Auth.stockroomEdit"
            >编辑</el-button
          >
          <el-popconfirm
            title="确认删除吗？"
            @confirm="handleDelete(scope.$index, scope.row)"
            v-permission="Auth.stockroomDelete"
          >
            <el-button slot="reference" type="danger" plain size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <stockroom-former
      :model="model"
      :show.sync="dialogVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></stockroom-former>
  </div>
</template>

<script>
import stockroomFormer from '@/components/stockroom'
import { stockroomList, deleteStockroom } from '@/service/getData'
import { clone } from '@/util'
import { id } from 'html-webpack-plugin/lib/chunksorter'

export default {
  components: {
    stockroomFormer,
  },
  data() {
    return {
      loading: true,
      page: 0,
      size: 1000,
      lists: [],
      model: {},
      search: '',
      dialogVisible: false,
      editIndex: 0,
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await stockroomList({ page: this.page, size: this.size })
      if (res.code == 0) {
        this.lists = res.data.list
        this.loading = false
      }
    },
    createdCallback(data) {
      this.lists.unshift(data)
    },
    updatedCallback(data) {
      this.lists[this.editIndex] = data
    },
    handleNew() {
      this.model = {
        name: '',
        address: '',
        remark: '',
        user_id: '',
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.dialogVisible = true
      this.editIndex = index
      this.$nextTick(() => {
        this.model = clone(item)
        if (this.model.user_id == 0) {
          this.model.user_id = ''
        }
      })
    },
    async handleDelete(index, item) {
      let res = await deleteStockroom(item.id)
      if (res.code == 0) {
        this.lists.splice(index, 1)
      }
    },
  },
}
</script>